import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * index.html には社内ツール向けに <meta name="robots" content="noindex, nofollow" />
 * が静的に埋め込まれている（SPAなので全ルート共通配信）。
 * 公開LP(/)だけは検索流入を狙うため、ルートがトップページの時だけこのmetaタグを取り除く。
 * それ以外のパスに遷移したら復元する。
 */
export function useRobotsMeta() {
  const { pathname } = useLocation();

  useEffect(() => {
    const meta = document.querySelector('meta[name="robots"]');
    if (pathname === '/') {
      meta?.remove();
    } else if (!meta) {
      const el = document.createElement('meta');
      el.setAttribute('name', 'robots');
      el.setAttribute('content', 'noindex, nofollow');
      document.head.appendChild(el);
    }
  }, [pathname]);
}
